(function ($) {
  Drupal.behaviors.contentBlockSidebysideV1 = {
    attach: function (context) {
      var self = this;
      var $modules = $('.js-content-block-sidebyside', context);

      $.each($modules, function () {
        var $module = $(this);

        self.setVideoCTAPosition($module);
        self.setListeners($module);
      });
    },
    setVideoCTAPosition: function ($module) {
      var videoCtaLeft = $module.data('video-cta-margin-left');
      var videoCtaRight = $module.data('video-cta-margin-right');
      var videoCtaTop = $module.data('video-cta-margin-top');
      var $videoTrigger = $module.find('.js-video-tout__trigger');

      if ($videoTrigger.length > 0) {
        if (videoCtaLeft) {
          $videoTrigger.css('margin-left', videoCtaLeft + '%');
        }
        if (videoCtaRight) {
          $videoTrigger.css('margin-right', videoCtaRight + '%');
        }
        if (videoCtaTop) {
          $videoTrigger.css('margin-top', videoCtaTop + '%');
        }
      }
    },
    setListeners: function ($module) {
      var $cta;
      var $interlocks = $module.find('.js-ctas-interlock');
      var $customVideoCta = $module.find('.js-cta__trigger');
      var $playTrigger = $module.find('.js-video-tout__trigger');
      var $interlock;

      if ($customVideoCta && $customVideoCta.length > 0) {
        $customVideoCta.each(function () {
          $cta = $(this);
          $cta.once().on('click', function () {
            if (!$playTrigger) {
              $playTrigger = $module.find('.js-video-tout__trigger');
            }
            $playTrigger.trigger('click');
          });
        });
      }
      if ($interlocks && $interlocks.children()) {
        $interlocks.children().first().addClass('active');
        $interlocks.children().off('click.cta').on('click.cta', function () {
          $interlock = $(this);
          $interlock.addClass('active');
          $interlock.siblings().removeClass('active');
        });
      }
    }
  };
})(jQuery);
